{
  "pageTitle": "Katalog nośników",
  "permissionDenied": "Brak dostępu do tej sekcji.",
  "table": {
    "columns": {
      "id": "ID",
      "supplierNumber": "Nr dostawcy",
      "format": "Format",
      "mediaType": "Typ nośnika",
      "noPhoto": "Zdjęcie",
      "city": "Miasto",
      "address": "Adres",
      "supplier": "Dostawca",
      "region": "Województwo",
      "dimensions": "Wymiary",
      "area": "Pow.",
      "lighting": "Oświetlenie",
      "catalogPrice": "Cena kat.",
      "agglomeration": "Aglomeracja",
      "county": "Powiat",
      "audienceEstimate": "Szac. odbiorców",
      "grwId": "Numer GRW",
      "material": "Materiał",
      "notes": "Notatki",
      "locationDescription": "Opis lokalizacji",
      "wfContactPerson": "Osoba kontakt WF/mural",
      "multiformat": "Multiformat",
      "tags": "Tagi",
      "rent": "Czynsz",
      "exposureCost": "Koszt ekspozycji",
      "additionalCosts": "Koszty dodatkowe",
      "discountedPrice": "Cena po rabacie",
      "lastMinutePrice": "Cena last minute",
      "starterPrice": "Na start",
      "productionCost": "Koszt produkcji",
      "installationCost": "Koszt montażu",
      "dismantlingCost": "Koszt demontażu",
      "clientProduction": "Produkcja",
      "clientInstallation": "Montaż",
      "clientDismantling": "Demontaż",
      "clientAdditionalFees": "Opłaty dodatkowe",
      "muralEcoProduction": "Produkcja ekomuralu",
      "roadNumber": "Nr drogi"
    },
    "columnVisibility": {
      "toggleButton": "Kolumny",
      "sectionLabel": "Widoczność kolumn",
      "searchPlaceholder": "Szukaj kolumn...",
      "noResults": "Nie znaleziono kolumny"
    },
    "availability": "Dostępność",
    "noPhotoAria": "Brak zdjęć",
    "hasPhotoAria": "Podgląd zdjęć nośnika",
    "rowLinkAriaLabel": "Otwórz szczegóły nośnika {{id}}",
    "maskedExplanation": "Nie masz uprawnień do wyświetlenia tej wartości."
  },
  "availability": {
    "loadMore": "Więcej",
    "enquireAvailability": "Zapytaj o dostępność",
    "enquireSubject": "Zapytanie o dostępność: {{unitLabel}}{{city}}",
    "setStatusManually": "Ustaw status ręcznie",
    "moreEntries": "+{{n}} więcej",
    "expandStackAriaLabel": "Rozwiń pełną listę rezerwacji",
    "reserveSingle": "Zarezerwuj okres: {{period}} dla {{unitLabel}}?",
    "addOptionBtn": "Stałka",
    "reserveBtn": "Zarezerwuj",
    "cancelBtn": "Anuluj",
    "closeBtn": "Zamknij",
    "prevWindow": "Poprzednie okno",
    "nextWindow": "Następne okno",
    "occupiedByOther": "Zarezerwowane przez innego użytkownika",
    "unavailableWindowMessage": "Niedostępne: {{period}}",
    "calendarReserve": {
      "statusReservation": "Rezerwacja",
      "statusOption": "Stałka",
      "dayCount_one": "{{count}} dzień",
      "dayCount_few": "{{count}} dni",
      "dayCount_many": "{{count}} dni",
      "dayCount_other": "{{count}} dni",
      "chooseOfferBtn": "Wybierz ofertę",
      "confirmBtn": "Potwierdź",
      "cancelBtn": "Anuluj",
      "noOfferSelectedHint": "Wybierz ofertę, aby kontynuować",
      "unitLabel": "Nośnik: {{label}}"
    },
    "inspect": {
      "status": {
        "option": "Stałka",
        "soft": "Wstępna",
        "hard": "Rezerwacja potwierdzona",
        "sold": "Sprzedana",
        "blocked": "Zablokowane"
      },
      "holderLabel": "Rezerwujący",
      "clientLabel": "Klient",
      "offerLabel": "Oferta",
      "sourceLabel": "Źródło",
      "expiresLabel": "Wygasa"
    },
    "select": {
      "summaryPrefix": "Zaznaczono",
      "periodsCount_one": "{{count}} okres",
      "periodsCount_few": "{{count}} okresy",
      "periodsCount_many": "{{count}} okresów",
      "periodsCount_other": "{{count}} okresów",
      "unitsCount_one": "{{count}} nośnik",
      "unitsCount_few": "{{count}} nośniki",
      "unitsCount_many": "{{count}} nośników",
      "unitsCount_other": "{{count}} nośników",
      "offerFieldLabel": "Oferta",
      "clearBtn": "Wyczyść",
      "reserveBtn": "Rezerwacja",
      "optionBtn": "Stałka",
      "releaseBtn": "Zwolnij",
      "queueJoinDisabledHint": "Kolejka dotyczy tylko jednego terminu.",
      "confirmReleaseTitle": "Zwolnij rezerwacje",
      "confirmReleaseSingleBody": "Zwolnisz rezerwację z oferty „{{offerName}}” na nośniku {{mediaUnit}}, termin: {{dateRange}}.",
      "confirmReleaseUnknownOffer": "nieznana oferta",
      "confirmReleaseUnknownUnit": "ten nośnik",
      "confirmReleaseCancelBtn": "Anuluj",
      "confirmReleaseSubmitBtn": "Zwolnij",
      "releaseModeChoice": {
        "title": "Co chcesz zwolnić?",
        "wholeLabel": "Cały okres rezerwacji",
        "selectedLabel": "Tylko zaznaczone dni"
      },
      "releaseResultToast": "Zwolniono {{released}} rezerwacji, opuszczono {{queuesLeft}} kolejek.",
      "releaseResultSelected": {
        "remainingRangeDetail": "Pozostaje zarezerwowane: {{range}}",
        "remainingRangesDetail": "Pozostaje zarezerwowane: {{rangeA}} oraz {{rangeB}}",
        "queuesLeftLabel": "Opuszczono {{count}} kolejek.",
        "reasonSold": "Rezerwacja została sprzedana.",
        "reasonNotHeld": "Nie posiadasz już tej rezerwacji.",
        "reasonNotFound": "Ta rezerwacja już nie istnieje.",
        "reasonNotInSelectedRange": "Terminy tej rezerwacji zmieniły się, zanim zwolnienie mogło zostać przetworzone.",
        "reasonGeneric": "Nie udało się zwolnić tej rezerwacji."
      },
      "confirmReleaseBreakdown": {
        "loading": "Obliczanie skutków zwolnienia…",
        "error": "Nie udało się obliczyć skutków zwolnienia.",
        "retryBtn": "Spróbuj ponownie",
        "empty": "Nie ma nic do zwolnienia w tym zaznaczeniu.",
        "releasableLabel": "Zostanie zwolnione",
        "queueExitLabel": "Opuści kolejkę",
        "unresolvableLabel": "Nie można zwolnić",
        "unresolvableSoldReason": "Rezerwacja została sprzedana — nośnik pozostanie bez zmian.",
        "remainingRangeDetail": "Pozostanie zarezerwowane: {{range}}",
        "remainingRangesDetail": "Pozostanie zarezerwowane: {{rangeA}} oraz {{rangeB}}"
      },
      "optionDialog": {
        "title": "Widoczność stałki",
        "excludedSummary_one": "{{count}} zajęty okres nie zostanie objęty stałką — jest już zajęty.",
        "excludedSummary_few": "{{count}} zajęte okresy nie zostaną objęte stałką — są już zajęte.",
        "excludedSummary_many": "{{count}} zajętych okresów nie zostanie objętych stałką — są już zajęte.",
        "excludedSummary_other": "{{count}} zajętych okresów nie zostanie objętych stałką — są już zajęte.",
        "modeDays": "Liczba dni",
        "modeDate": "Data",
        "confirmBtn": "Potwierdź",
        "cancelBtn": "Anuluj"
      },
      "reserveDialog": {
        "title": "Potwierdź rezerwację",
        "dateRangeLabel": "Zakres dat rezerwacji",
        "dateLabel": "Termin wygaśnięcia",
        "datePlaceholder": "Wybierz termin",
        "autoHint": "Terminy wygaśnięcia różnią się dla wybranych nośników — proponujemy najpóźniejszy z wyliczonych terminów; możesz go zmienić w kalendarzu.",
        "description": "System proponuje termin wygaśnięcia — możesz go zmienić w kalendarzu.",
        "splitSummary": "{{reservedCount}} zostanie zarezerwowanych od razu, a {{queuedCount}} trafi do kolejki. Wspólny termin wygaśnięcia obejmuje też okresy w kolejce — jeśli zostaną promowane po jego upływie, otrzymają standardowy termin kolejkowy.",
        "confirmBtn": "Rezerwuj",
        "cancelBtn": "Anuluj"
      },
      "reserveResult": {
        "reservedLabel": "Zarezerwowano",
        "queuedLabel": "W kolejce",
        "failedLabel": "Niepowodzenie",
        "expiresOn": "wygasa {{date}}",
        "dismissBtn": "Zamknij wynik"
      }
    }
  },
  "filters": {
    "region": "Województwo",
    "county": "Powiat",
    "agglomeration": "Aglomeracja",
    "city": "Miasto",
    "location": "Lokalizacja",
    "locationSearchPlaceholder": "Szukaj województwa, powiatu, aglomeracji, miasta…",
    "locationInfoHint": "Wybrane obszary sumują się (LUB) — dodawaj lokalizacje, aby poszerzyć wyniki. Pozostałe filtry zawężają wynik.",
    "locationInfoHintLabel": "Informacja o filtrze lokalizacji",
    "administrativeArea": "Dzielnica",
    "formatCode": "Format",
    "mediaType": "Typ nośnika",
    "supplierId": "Dostawca",
    "supplierNumber": "Nr dostawcy",
    "grwId": "Nr wewnętrzny",
    "lighting": "Oświetlenie",
    "material": "Materiał",
    "multiformat": "Multiformat",
    "tags": "Tagi",
    "address": "Adres",
    "area": "Powierzchnia",
    "width": "Szerokość",
    "height": "Wysokość",
    "audience": "Widownia",
    "catalogPrice": "Cena katalogowa",
    "rent": "Czynsz",
    "exposureCost": "Koszt ekspozycji",
    "additionalCosts": "Koszty dodatkowe",
    "discountedPrice": "Cena po rabacie",
    "lastMinutePrice": "Cena last minute",
    "starterPrice": "Na start",
    "productionCost": "Koszt produkcji",
    "installationCost": "Koszt montażu",
    "dismantlingCost": "Koszt demontażu",
    "clientProduction": "Produkcja",
    "clientInstallation": "Montaż",
    "clientDismantling": "Demontaż",
    "clientAdditionalFees": "Opłaty dodatkowe",
    "notes": "Uwagi",
    "roadNumber": "Nr drogi",
    "rangeMinLabel": "Min",
    "rangeMaxLabel": "Max",
    "noPhoto": "Bez zdjęcia",
    "availability": "Dostępność",
    "importJobChip": "Import #{{id}}",
    "status": "Status",
    "toggleLabel": "Filtry",
    "searchPlaceholder": "Szukaj...",
    "searchBox": {
      "placeholder": "Szukaj po numerze, adresie, mieście...",
      "ariaLabel": "Szukaj nośników",
      "openOnMap": "Otwórz na mapie"
    },
    "exclude": {
      "include": "Uwzględnij",
      "exclude": "Wyklucz",
      "toggleAria": "Przełącz tryb wykluczania dla filtra {{field}}"
    },
    "allLabel": "Wszystkie",
    "cancelLabel": "Anuluj",
    "applyLabel": "Zastosuj",
    "selectedCountLabel": "{{n}} wybrane",
    "clearLabel": "Wyczyść",
    "clearAllLabel": "Wyczyść wszystkie",
    "showLessLabel": "Mniej",
    "addFilterLabel": "Dodaj filtr",
    "removeAriaLabel": "Usuń filtr {{label}}"
  },
  "toolbar": {
    "addButton": "Dodaj nośnik",
    "mapButton": "Mapa",
    "importMenuButton": "Import…",
    "importMediaButton": "Zaktualizuj nośniki",
    "importAvailabilityButton": "Zaktualizuj dostępność"
  },
  "quickAdd": {
    "addAllFiltered": "Dodaj wszystkie do oferty",
    "rowActionLabel": "Dodaj do oferty",
    "rowActionAriaLabel": "Dodaj {{id}} do oferty",
    "bulkActionLabel": "Dodaj zaznaczone do oferty",
    "toolbarAriaLabel": "Akcje zbiorcze szybkiego dodawania do oferty",
    "selectedCountSuffix_one": "zaznaczony",
    "selectedCountSuffix_few": "zaznaczone",
    "selectedCountSuffix_many": "zaznaczonych",
    "selectedCountSuffix_other": "zaznaczonych",
    "visibleCountSuffix_one": "widoczny",
    "visibleCountSuffix_few": "widoczne",
    "visibleCountSuffix_many": "widocznych",
    "visibleCountSuffix_other": "widocznych",
    "moreActionsLabel": "Więcej akcji",
    "clearSelectionLabel": "Wyczyść zaznaczenie",
    "limitExceeded": "Wybierz maksymalnie 100 nośników.",
    "subtitle_one": "Dodajesz {{count}} nośnik",
    "subtitle_few": "Dodajesz {{count}} nośniki",
    "subtitle_many": "Dodajesz {{count}} nośników",
    "subtitle_other": "Dodajesz {{count}} nośników",
    "confirmExistingWithCount_one": "Dodaj {{count}} nośnik",
    "confirmExistingWithCount_few": "Dodaj {{count}} nośniki",
    "confirmExistingWithCount_many": "Dodaj {{count}} nośników",
    "confirmExistingWithCount_other": "Dodaj {{count}} nośników",
    "confirmNewWithCount_one": "Utwórz i dodaj {{count}} nośnik",
    "confirmNewWithCount_few": "Utwórz i dodaj {{count}} nośniki",
    "confirmNewWithCount_many": "Utwórz i dodaj {{count}} nośników",
    "confirmNewWithCount_other": "Utwórz i dodaj {{count}} nośników",
    "selection": {
      "selectAllAriaLabel": "Zaznacz wszystkie nośniki",
      "selectRowAriaLabel": "Zaznacz {{id}} {{city}}"
    },
    "picker": {
      "title": "Dodaj do oferty",
      "subtitle": "Wybierz ofertę docelową",
      "draftUnitLabel": "nośników",
      "draftSummarySeparator": "•",
      "pendingUnitsLabel": "Dodajesz",
      "targetOfferLabel": "Oferta docelowa",
      "searchPlaceholder": "Szukaj oferty",
      "createNewLinkLabel": "Dodaj nową",
      "changeSelectionLabel": "Zmień",
      "pickOfferLabel": "Wybierz ofertę docelową",
      "cancelChangeLabel": "Anuluj zmianę",
      "backToExistingLabel": "Wróć do istniejących",
      "lastUsedHintLabel": "Ostatnio używana oferta jest wybrana domyślnie.",
      "destinationLabel": "Dodasz do",
      "creationStatusHintLabel": "Nowa oferta zostanie utworzona przy zapisie.",
      "noPreselectionLabel": "Nie wybrano jeszcze oferty.",
      "noDraftsLabel": "Brak ofert roboczych.",
      "noPermissionLabel": "Nie masz uprawnień do edycji ofert.",
      "noResultsLabel": "Nie znaleziono oferty pasującej do wyszukiwania.",
      "createNewLabel": "Nowa oferta",
      "createNewHint": "Utwórz nową ofertę roboczą.",
      "clientFieldLabel": "Klient",
      "clientFieldPlaceholder": "Wybierz klienta",
      "salespersonFieldLabel": "Handlowiec",
      "salespersonFieldPlaceholder": "Wybierz handlowca",
      "salespersonFieldLockedHint": "Nie masz uprawnień do przypisania oferty innemu handlowcowi.",
      "campaignDurationLabel": "Czas trwania kampanii",
      "campaignDurationPlaceholder": "Wybierz zakres dat",
      "campaignDurationInvalidRangeLabel": "Data zakończenia musi być taka sama lub późniejsza niż data początkowa",
      "confirmExistingLabel": "Dodaj",
      "confirmNewLabel": "Utwórz i dodaj",
      "cancelLabel": "Anuluj",
      "openFullFormLabel": "Otwórz pełny formularz",
      "openFullFormHint": "Dalsza konfiguracja w pełnym formularzu.",
      "validationClientRequiredLabel": "Wybierz klienta"
    }
  },
  "footer": {
    "shown": "Wyświetlono",
    "of": "z",
    "units": "nośników"
  },
  "emptyState": "Brak nośników do wyświetlenia",
  "emptyStateImportJob": "Ten import nie zawiera żadnych pasujących nośników",
  "emptyStatePermissionScope": "Brak nośników do wyświetlenia — przyczyną może być ograniczony zakres uprawnień",
  "errorState": "Nie udało się załadować nośników",
  "campaign": {
    "saveToButton": "Zapisz do kampanii",
    "savedToast": "Filtry zapisane do kampanii",
    "saveDialogTitle": "Zapisz filtry do kampanii",
    "saveDialogDescription": "Filtry zostaną przywrócone przy kolejnym wejściu do kampanii."
  },
  "detail": {
    "tags": {
      "sectionTitle": "Tagi",
      "empty": "Brak tagów",
      "clientVisibleMarker": "C"
    },
    "pageTitle": "Nośnik {{displayNumber}}",
    "backLink": "Katalog nośników",
    "backToMap": "Powrót do mapy",
    "clientDetail": {
      "backToOffer": "Powrót do oferty",
      "notFound": "Nie znaleziono nośnika"
    },
    "editButton": "Edytuj",
    "deleteButton": "Usuń nośnik",
    "deleteConfirm": "Czy na pewno chcesz usunąć nośnik {{grwId}}?",
    "deleteSuccess": "Nośnik został usunięty",
    "deleteError": "Nie udało się usunąć nośnika",
    "deleteBlockedByDraftOffer": "Nie można usunąć: nośnik jest wykorzystywany w drafcie oferty. Najpierw usuń go z draftu.",
    "deleteDialogTitle": "Usuń nośnik",
    "deleteDialogCancel": "Anuluj",
    "deleteDialogConfirm": "Usuń",
    "perMonth": "PLN / miesiąc",
    "noPhotos": "Brak zdjęć",
    "downloadPhoto": "Pobierz zdjęcie",
    "downloadAllPhotos": "Pobierz wszystkie zdjęcia",
    "openLightbox": "Powiększ zdjęcie",
    "lightbox": {
      "close": "Zamknij",
      "previous": "Poprzednie zdjęcie",
      "next": "Następne zdjęcie",
      "counter": "{{current}} / {{total}}"
    },
    "availabilityCalendar": "Kalendarz dostępności",
    "availabilityLastUpdatedHintLabel": "Kiedy zaktualizowano dostępność",
    "availabilityLastUpdatedHint": "Dostępność ostatnio zaktualizowano: {{date}}",
    "noNotes": "Brak uwag",
    "bundle": {
      "title": "Pakiet",
      "description": "Ten nośnik jest częścią pakietu (dwie strony tej samej konstrukcji)."
    },
    "sections": {
      "identification": "Identyfikacja",
      "location": "Lokalizacja",
      "specs": "Specyfikacja techniczna",
      "costs": "Koszty",
      "notes": "Uwagi",
      "supplier": "Dostawca",
      "additionalServices": "Usługi dodatkowe"
    },
    "calendar": {
      "reserved": "Zarezerwowane",
      "available": "Dostępne",
      "prevMonth": "Poprzedni miesiąc",
      "nextMonth": "Następny miesiąc"
    },
    "openInGoogleMaps": "Otwórz w Google Maps",
    "techSpec": {
      "title": "Specyfikacje techniczne",
      "emptyState": "Brak załączonych specyfikacji",
      "uploadZoneHint": "Przeciągnij plik lub kliknij, aby wybrać",
      "uploadZoneFormats": ".doc, .docx, .xls, .pdf - maks. 20 MB",
      "uploadButton": "Dodaj specyfikację",
      "uploading": "Przesyłanie pliku...",
      "errorType": "Niedozwolony typ pliku",
      "errorTypeHint": "Dozwolone formaty: .doc, .docx, .xls, .pdf",
      "errorSize": "Plik jest za duży",
      "errorSizeHint": "Maksymalny rozmiar pliku: 20 MB",
      "dragOver": "Upuść plik tutaj",
      "deleteConfirmTitle": "Usunąć plik?",
      "deleteConfirmDescription": "Czy na pewno chcesz usunąć ten plik? Tej operacji nie można cofnąć.",
      "deleteConfirmCancel": "Anuluj",
      "deleteConfirmConfirm": "Usuń",
      "deleteError": "Nie udało się usunąć pliku. Spróbuj ponownie."
    },
    "fields": {
      "supplierNumber": "Nr dostawcy",
      "supplier": "Dostawca",
      "format": "Format",
      "mediaType": "Typ nośnika",
      "status": "Status",
      "address": "Adres",
      "region": "Województwo",
      "county": "Powiat",
      "agglomeration": "Aglomeracja",
      "city": "Miasto",
      "gpsCoordinates": "Współrzędne GPS",
      "locationDescription": "Opis lokalizacji",
      "dimensions": "Wymiary",
      "area": "Powierzchnia",
      "material": "Materiał",
      "lighting": "Oświetlenie",
      "catalogPrice": "Cena katalogowa",
      "rent": "Czynsz",
      "exposureCost": "Koszt ekspozycji",
      "installCost": "Koszt montażu",
      "dismantlingCost": "Koszt demontażu",
      "productionCost": "Koszt produkcji",
      "additionalCosts": "Koszt dodatkowy",
      "starterPrice": "Cena wyjściowa",
      "discountedPrice": "Cena po rabacie",
      "clientProduction": "Produkcja",
      "muralEcoProduction": "Produkcja ekomuralu",
      "clientInstallation": "Montaż",
      "clientDismantling": "Demontaż",
      "clientAdditionalFees": "Opłaty dodatkowe",
      "priceSum": "Suma"
    },
    "costs": {
      "toggleAria": "Zwiń/rozwiń sekcję kosztów"
    },
    "availability": {
      "toggleAria": "Zwiń/rozwiń kalendarz dostępności"
    }
  },
  "form": {
    "add": {
      "title": "Nowy nośnik",
      "pageTitle": "Dodaj nośnik",
      "subtitle": "Uzupełnij dane nośnika reklamowego.",
      "requiredHint": "Pola oznaczone * są wymagane."
    },
    "saveErrorMessage": "Nie udało się zapisać zmian. Sprawdź dane i spróbuj ponownie.",
    "saveError": "Wystąpił błąd podczas zapisywania",
    "supplierNumberCollision": "Ten numer dostawcy jest już przypisany do innego nośnika tego dostawcy.",
    "loadingPlaceholder": "Ładowanie...",
    "edit": {
      "title": "Edytuj nośnik",
      "pageTitle": "Edytuj nośnik {{displayNumber}}",
      "backLink": "Szczegóły nośnika",
      "unsavedBadge": "Niezapisane zmiany",
      "subtitleText": "Edytujesz nośnik {{displayNumber}}.",
      "requiredHint": "Pola oznaczone * są wymagane.",
      "successTitle": "Zmiany zostały zapisane",
      "successDescription": "Nośnik {{displayNumber}} został zaktualizowany. Historia zmian kosztów jest zachowana.",
      "discardTitle": "Masz niezapisane zmiany",
      "discardMessage": "Czy na pewno chcesz porzucić wprowadzone zmiany? Ta operacja jest nieodwracalna.",
      "discardConfirm": "Porzuć zmiany",
      "discardCancel": "Kontynuuj edycję"
    },
    "successAdd": {
      "title": "Nośnik został dodany pomyślnie",
      "description": "Nowy nośnik jest teraz widoczny w katalogu nośników.",
      "addAnother": "Dodaj kolejny nośnik",
      "goToCatalog": "Przejdź do katalogu"
    },
    "sections": {
      "photos": "Zdjęcia",
      "photosSubtitle": "Dodaj zdjęcia nośnika.",
      "photosEditSubtitle": "Zarządzaj zdjęciami nośnika. Istniejące zdjęcia można usunąć, nowe dodać.",
      "supplier": "Dane dostawcy",
      "technical": "Specyfikacja techniczna",
      "location": "Lokalizacja",
      "costs": "Koszty",
      "costsSubtitle": "Koszty są trwale zapisywane przy dodawaniu nośnika. Historia zmian jest zachowywana.",
      "costsEditSubtitle": "Zmiana kosztów jest rejestrowana w historii. Poprzednie wartości są zachowywane.",
      "prices": "Ceny",
      "notes": "Uwagi"
    },
    "fields": {
      "supplierNumber": "Nr dostawcy",
      "supplier": "Dostawca",
      "format": "Format",
      "material": "Materiał",
      "lighting": "Oświetlenie",
      "width": "Szerokość (m)",
      "height": "Wysokość (m)",
      "area": "Powierzchnia (m²)",
      "region": "Województwo",
      "county": "Powiat",
      "agglomeration": "Aglomeracja",
      "city": "Miasto",
      "address": "Adres",
      "latitude": "Szerokość geogr. (latitude)",
      "longitude": "Długość geogr. (longitude)",
      "catalogPrice": "Cena katalogowa (PLN)",
      "rent": "Czynsz (PLN)",
      "productionCost": "Koszt produkcji (PLN)",
      "installCost": "Koszt montażu (PLN)",
      "dismantlingCost": "Koszt demontażu (PLN)",
      "exposureCost": "Koszt ekspozycji (PLN)",
      "additionalCosts": "Koszt dodatkowy (PLN)",
      "discountedPrice": "Cena po rabacie (PLN)",
      "lastMinutePrice": "Cena last minute (PLN)",
      "starterPrice": "Na start (PLN)",
      "clientProduction": "Produkcja (PLN)",
      "clientInstallation": "Montaż (PLN)",
      "clientDismantling": "Demontaż (PLN)",
      "clientAdditionalFees": "Opłaty dodatkowe (PLN)",
      "notes": "Uwagi",
      "wfContactPerson": "Osoba do kontaktu przy WF i muralach",
      "locationDescription": "Opis lokalizacji",
      "rentDisabledHint": "Nie masz uprawnień do edycji czynszu.",
      "costsDisabledHint": "Nie masz uprawnień do edycji kosztów.",
      "supplierDisabledHint": "Nie masz uprawnień do edycji danych dostawcy."
    },
    "placeholders": {
      "supplierNumber": "np. AMS-WAW-044",
      "supplier": "Wybierz dostawcę...",
      "format": "Wybierz format...",
      "material": "Wybierz materiał...",
      "lighting": "Wybierz oświetlenie...",
      "clearSelection": "— brak —",
      "region": "Wybierz województwo...",
      "county": "Wybierz powiat...",
      "countyNoRegion": "Najpierw wybierz województwo",
      "agglomeration": "np. Warszawska",
      "city": "np. Warszawa",
      "address": "np. Marszałkowska 12, kier. Centrum",
      "latitude": "np. 52.2297",
      "longitude": "np. 21.0122",
      "width": "np. 6",
      "height": "np. 3",
      "area": "Auto",
      "catalogPrice": "np. 4500",
      "rent": "np. 3200",
      "productionCost": "np. 450",
      "installCost": "np. 350",
      "dismantlingCost": "np. 200",
      "exposureCost": "np. 4500",
      "additionalCosts": "np. 100",
      "discountedPrice": "np. 4000",
      "lastMinutePrice": "np. 3500",
      "starterPrice": "np. 3000",
      "clientProduction": "np. 500",
      "clientInstallation": "np. 400",
      "clientDismantling": "np. 250",
      "clientAdditionalFees": "np. 150",
      "notes": "Dodatkowe informacje o nośniku...",
      "wfContactPerson": "Imię i nazwisko osoby kontaktowej...",
      "locationDescription": "Opisowa lokalizacja nośnika, np. naroznik ulic..."
    },
    "validation": {
      "supplierNumberRequired": "Nr dostawcy jest wymagany",
      "supplierRequired": "Dostawca jest wymagany",
      "formatRequired": "Format jest wymagany",
      "regionRequired": "Województwo jest wymagane",
      "cityRequired": "Miasto jest wymagane",
      "addressRequired": "Adres jest wymagany",
      "widthRequired": "Szerokość jest wymagana",
      "widthPositive": "Szerokość musi być większa od 0",
      "heightRequired": "Wysokość jest wymagana",
      "heightPositive": "Wysokość musi być większa od 0",
      "nonNegative": "Wartość nie może być ujemna",
      "mustBeValidSelection": "Wybierz poprawną wartość",
      "invalidCoordinate": "Podaj prawidłową współrzędną (np. 52.2297 lub 50°54'05.8\"N)",
      "requiredFieldsMissing": "Uzupełnij wymagane pola, aby zapisać zmiany."
    },
    "photos": {
      "dropzone": "Przeciągnij zdjęcia lub kliknij, aby wybrać",
      "dropzoneEdit": "Przeciągnij zdjęcia lub kliknij",
      "hint": "JPG, PNG do 10 MB. Maks. 10 zdjęć.",
      "hintEdit": "JPG, PNG, WebP do 10 MB. Maks. 10 zdjęć.",
      "selectFiles": "Wybierz pliki",
      "tooMany": "Można dodać maksymalnie 10 zdjęć",
      "tooManyDetailed": "Pominięto {{count}} zdjęć (przekroczono limit 10): {{names}}.",
      "wrongType": "Dozwolone są tylko pliki JPG, PNG lub WebP",
      "wrongTypeDetailed": "Nie dodano {{count}} plików (nieobsługiwany format): {{names}}. Obsługiwane formaty: JPG, PNG, WebP.",
      "loading": "Ładowanie danych...",
      "removeAriaLabel": "Usuń {{name}}"
    },
    "costHistory": {
      "title": "Historia zmian kosztów",
      "noHistory": "Brak historii zmian kosztów",
      "field": "Pole",
      "previousValue": "Poprzednia wartość",
      "newValue": "Nowa wartość",
      "date": "Data",
      "catalogPrice": "Cena katalogowa",
      "rent": "Czynsz",
      "printCost": "Koszt druku",
      "installCost": "Koszt montażu",
      "dismantlingCost": "Koszt demontażu",
      "productionCost": "Koszt produkcji"
    },
    "tags": {
      "sectionTitle": "Tagi",
      "placeholder": "Wybierz tagi...",
      "searchPlaceholder": "Szukaj tagów...",
      "noResults": "Brak wyników",
      "removeAriaLabel": "Usuń tag {{label}}",
      "inactiveHint": "(nieaktywny)"
    },
    "saveButton": {
      "idle": "Zapisz nośnik",
      "saving": "Zapisywanie...",
      "saved": "Zapisano!",
      "error": "Błąd zapisu",
      "saveChanges": "Zapisz zmiany"
    }
  },
  "bulkEdit": {
    "action": "Edytuj masowo",
    "drawerTitle": "Edycja masowa",
    "fieldLabel": "Pole do edycji",
    "valueLabel": "Nowa wartość",
    "confirmTitle": "Potwierdzenie edycji masowej",
    "confirmMessage": "{{count}} nośników zostanie zaktualizowanych.",
    "hiddenCount": "{{count}} poza bieżącymi wynikami.",
    "submit": "Zaktualizuj",
    "cancel": "Anuluj",
    "successToast": "{{updated}} zaktualizowanych, {{failed}} błędów",
    "failedToast": "Edycja masowa nie powiodła się",
    "selectAll": "Zaznacz wszystkie {{count}} pasujące",
    "capWarning": "Edycja masowa jest ograniczona do 500 nośników. Zmniejsz wybór lub zastosuj dokładniejszy filtr.",
    "toolbarAriaLabel": "Akcje zbiorcze edycji nośników",
    "selectedCountSuffix": "zaznaczonych",
    "moreActionsLabel": "Więcej akcji",
    "clearSelectionLabel": "Wyczyść zaznaczenie",
    "nextBtn": "Dalej",
    "backBtn": "Wróć",
    "selectPlaceholder": "Wybierz wartość...",
    "fields": {
      "mediaType": "Typ nośnika",
      "city": "Miasto",
      "lifecycleStatus": "Status cyklu życia",
      "supplier": "Dostawca"
    },
    "lifecycleStatus": {
      "active": "Aktywny",
      "inactive": "Nieaktywny",
      "archived": "Zarchiwizowany"
    },
    "errors": {
      "generic": "Nie udało się zapisać edycji masowej. Spróbuj ponownie."
    }
  },
  "bulkMarkAvailability": {
    "action": "Zablokuj dostępność",
    "drawerTitle": "Zablokuj dostępność masowo",
    "presetFirstHalf": "1-15",
    "presetSecondHalf": "16-koniec miesiąca",
    "dateRangeLabel": "Okres dostępności",
    "dateRangePlaceholder": "Wybierz zakres dat…",
    "stateLabel": "Stan",
    "statePlaceholder": "Wybierz stan...",
    "state": {
      "FREE": "Wolne",
      "UNAVAILABLE": "Niedostępne"
    },
    "confirmMessage": "{{count}} nośników zostanie zaktualizowanych.",
    "hiddenCount": "{{count}} poza bieżącymi wynikami.",
    "submit": "Zablokuj",
    "cancel": "Anuluj",
    "resultToast": "{{updated}} zaktualizowanych, {{failed}} błędów",
    "capWarning": "Akcja masowa jest ograniczona do 500 nośników. Zmniejsz wybór lub zastosuj dokładniejszy filtr."
  },
  "bulkRecomputeLocation": {
    "action": "Przelicz lokalizację",
    "dialogTitle": "Przelicz lokalizację",
    "confirmMessage": "Przeliczy województwo, powiat i aglomerację na podstawie współrzędnych dla {{count}} nośników.",
    "hiddenCount": "{{count}} poza bieżącymi wynikami.",
    "submit": "Przelicz",
    "cancel": "Anuluj",
    "resultToast": "{{updated}} zaktualizowanych, {{failed}} błędów",
    "capWarning": "Akcja masowa jest ograniczona do 500 nośników. Zmniejsz wybór lub zastosuj dokładniejszy filtr."
  },
  "bulkDelete": {
    "action": "Usuń zaznaczone",
    "dialogTitle": "Usuń zaznaczone nośniki",
    "confirmMessage": "Usunie {{count}} nośników. Trafią one do kosza i można je przywrócić w ciągu 3 dni.",
    "hiddenCount": "{{count}} poza bieżącymi wynikami.",
    "submit": "Usuń",
    "cancel": "Anuluj",
    "resultToast": "{{deleted}} usuniętych, {{failed}} pominiętych",
    "capWarning": "Akcja masowa jest ograniczona do 500 nośników. Zmniejsz wybór lub zastosuj dokładniejszy filtr."
  },
  "offerContext": {
    "bar": {
      "message": "Dodajesz do oferty: {{offerName}}",
      "returnLabel": "Wróć do oferty",
      "exitAriaLabel": "Zakończ dodawanie do oferty"
    }
  },
  "tags": {
    "pageTitle": "Słowniki systemowe - Tagi",
    "pageSubtitle": "Zarządzanie tagami nośników reklamowych",
    "permissionDenied": "Brak dostępu do tej sekcji.",
    "actions": {
      "addTag": "Dodaj tag",
      "edit": "Edytuj",
      "deactivate": "Dezaktywuj",
      "deletePermanent": "Usuń trwale"
    },
    "deletePermanent": {
      "title": "Usunąć trwale tag „{{name}}”?",
      "description": "Tag zostanie trwale usunięty i zniknie ze wszystkich nośników, które go miały. Tej operacji nie można cofnąć.",
      "affectedUnits_one": "Tag jest przypisany do {{count}} nośnika — zostanie z niego zdjęty.",
      "affectedUnits_few": "Tag jest przypisany do {{count}} nośników — zostanie z nich zdjęty.",
      "affectedUnits_many": "Tag jest przypisany do {{count}} nośników — zostanie z nich zdjęty.",
      "affectedUnits_other": "Tag jest przypisany do {{count}} nośników — zostanie z nich zdjęty.",
      "confirm": "Usuń trwale",
      "cancel": "Anuluj"
    },
    "filters": {
      "searchPlaceholder": "Szukaj po kodzie lub etykiecie...",
      "statusAll": "Wszystkie",
      "statusActive": "Aktywne",
      "statusInactive": "Nieaktywne"
    },
    "table": {
      "code": "Kod",
      "label": "Etykieta",
      "clientVisible": "Widoczny dla klienta",
      "clientVisibleYes": "Tak",
      "clientVisibleNo": "Nie",
      "sortOrder": "Kolejność",
      "status": "Status"
    },
    "empty": {
      "title": "Brak tagów",
      "description": "Dodaj pierwszy tag, aby rozpocząć."
    },
    "dialog": {
      "createTitle": "Nowy tag",
      "editTitle": "Edytuj tag",
      "close": "Zamknij",
      "cancel": "Anuluj",
      "save": "Zapisz",
      "saving": "Zapisywanie...",
      "fields": {
        "code": "Kod",
        "codePlaceholder": "np. zakaz_alkoholu",
        "codeHint": "Stabilny klucz importowy – małe litery, bez spacji.",
        "label": "Etykieta",
        "labelPlaceholder": "Nazwa wyświetlana",
        "sortOrder": "Kolejność",
        "isClientVisible": "Widoczny dla klienta",
        "isActive": "Aktywny"
      }
    },
    "errors": {
      "codeTaken": "Tag z tym kodem już istnieje."
    },
    "status": {
      "active": "Aktywny",
      "inactive": "Nieaktywny"
    },
    "pagination": {
      "page": "Strona {{page}} z {{total}} ({{count}} wyników)",
      "prev": "Poprzednia strona",
      "next": "Następna strona",
      "goToPage": "Strona {{page}}"
    }
  },
  "bulkDownload": {
    "dialog": {
      "title": "Pobierz specyfikacje techniczne",
      "fileCount_one": "{{count}} plik",
      "fileCount_few": "{{count}} pliki",
      "fileCount_many": "{{count}} plików",
      "fileCount_other": "{{count}} plików",
      "totalSize": "Łączny rozmiar: {{size}}",
      "largeSizeWarning": "Pobieranie może potrwać dłużej ze względu na rozmiar archiwum.",
      "skippedUnitsWarning": "{{skipped}} z {{total}} nośników nie ma załączonych specyfikacji i zostaną pominięte.",
      "confirmBtn": "Pobierz",
      "cancelBtn": "Anuluj"
    },
    "trigger": {
      "label": "Pobierz specyfikacje",
      "disabledEmpty": "Wybierz nośniki do pobrania",
      "disabledCap": "Można pobrać maksymalnie 200 nośników jednocześnie"
    },
    "toast": {
      "skippedFiles": "Pominięto {{count}} pliki: {{files}}",
      "manifestError": "Nie udało się pobrać listy plików",
      "streamError": "Błąd podczas pobierania pliku"
    }
  },
  "supplierPhotoZip": {
    "trigger": {
      "label": "Pobierz zdjęcia dostawcy"
    },
    "bulkTrigger": {
      "label": "Pobierz zdjęcia zaznaczonych",
      "disabledEmpty": "Wybierz nośniki do pobrania",
      "disabledCap": "Można pobrać maksymalnie 200 nośników jednocześnie"
    },
    "toast": {
      "skippedFiles": "Pominięto {{count}} zdjęcia: {{files}}",
      "manifestError": "Nie udało się pobrać listy zdjęć",
      "streamError": "Błąd podczas pobierania zdjęć"
    }
  },
  "trash": {
    "pageTitle": "Kosz nośników",
    "link": "Kosz",
    "emptyState": "Brak usuniętych nośników",
    "table": {
      "columns": {
        "grwId": "ID GRW",
        "city": "Miasto",
        "deletedAt": "Data usunięcia",
        "expiresAt": "Wygasa"
      }
    },
    "countdown": {
      "remaining": "{{days}}d {{hours}}h pozostało",
      "today": "Wygasa dziś",
      "expired": "Wygasł"
    },
    "actions": {
      "restore": "Przywróć"
    },
    "restore": {
      "success": "Nośnik przywrócony",
      "error": "Błąd przywracania nośnika"
    },
    "referencedByOffers_one": "Wykorzystywany w {{count}} ofercie — nie zostanie automatycznie usunięty",
    "referencedByOffers_few": "Wykorzystywany w {{count}} ofertach — nie zostanie automatycznie usunięty",
    "referencedByOffers_many": "Wykorzystywany w {{count}} ofertach — nie zostanie automatycznie usunięty",
    "referencedByOffers_other": "Wykorzystywany w {{count}} ofertach — nie zostanie automatycznie usunięty"
  }
}
